export const dnvRoles = {
  auditor: 'Auditor',
  project: 'Project',
  global: 'Global',
  country: 'Country',
} as const;

export type DnvUserRoleType = (typeof dnvRoles)[keyof typeof dnvRoles] | null;

export const dnvRolesWithRestriction: DnvUserRoleType[] = [
  dnvRoles.auditor,
  dnvRoles.project,
];
